export const ContentTagResources = {
  getContent: {
    url: "/contents/tag_list",
    asyncActions: {
      init: "getContentTag_INIT",
      success: "getContentTag_SUCCESS",
      error: "getContentTag_ERROR"
    }
  }
};

const initialState = {
  list: undefined,
  links: undefined,
  status: undefined,
  statusText: undefined,
  meta: undefined,
  deleted: undefined,
  edited: undefined,
  hasList: undefined,
  loading: undefined,
  hasError: undefined
};

export function ContentTag(state = { initialState }, action = {}) {
  const { init, success, error } = ContentTagResources.getContent.asyncActions;

  switch (action.type) {
    case init: {
      return {
        ...state,
        loading: true,
        hasError: undefined
      };
    }

    case success: {
      const {
        data: {
          _jsonapi: { data },
          links,
          meta
        },
        status,
        statusText
      } = action.payload;
      return {
        list: data,
        links,
        status,
        statusText,
        meta,
        deleted: [],
        edited: [],
        hasList: true,
        loading: false,
        hasError: false
      };
    }

    case error: {
      return {
        ...state,
        loading: false,
        hasError: true
      };
    }

    default: {
      return state;
    }
  }
}
